import React from 'react';

interface FooterProps extends React.HTMLAttributes<HTMLElement> {
  style?: React.CSSProperties;
}

const Footer: React.FC<FooterProps> = ({ style, ...rest }) => (
  <footer
    style={{
      width: '100%',
      textAlign: 'center',
      padding: '16px 0',
      color: '#999',
      fontSize: 14,
      background: 'transparent',
      position: 'relative',
      bottom: 0,
      ...style,
    }}
    {...rest}
  >
    Copyright © {new Date().getFullYear()} All rights reserved.{' '}
    <a
      href="http://beian.miit.gov.cn"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#999',
        textDecoration: 'none',
      }}
    >
      粤ICP备2025408736号-1
    </a>
  </footer>
);

export default Footer; 